<template>
    <div class="upgrade-wrap">
        <!--  升级弹框 -->
        <a-modal
            :visible="visibleUpgrade"
            title='升级'
            @cancel="closeModalUpgrade"
            @ok="showConfirm"
            :width="800"
            :confirmLoading="confirmLoading"
            :destroyOnClose="true"
            >
            <div class="mb16">
                <a-card title="原票/卡券" >
                    <member-card :ticketData="data" :showOwner="false"></member-card>
                </a-card>
            </div>
                <a-card title="升级票/卡券" >
                    <a-form class="upgrade-form" :form="formModelUpgrade">
                        <a-row>
                            <a-col :span="12">
                                <a-form-item label="门店选择" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                                    <a-select @change="changeUpgradeTicket" placeholder="请选择" :options="shopList" v-decorator="['shopId', {rules: [{required: true, message: '请选择门店'}]}]"></a-select>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="12">
                                <a-form-item label="升级票券类型" :labelCol="{span: 7}" :wrapperCol="wrapperCol" >
                                    <a-radio-group v-decorator="['upgradeType', {initialValue: 2}, {rules: [{required:true}]}]" @change="onChangeType">
                                        <a-radio :value="1">门店票</a-radio>
                                        <a-radio :value="2">活动票</a-radio>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="12">
                                <a-form-item label="票/卡券名称" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                                    <a-select placeholder="请选择" @change="changeTicket" v-decorator="['ticketFlagId', {rules: [{required: true, message: '请选择票/卡券'}]}]"  >
                                        <a-select-option :value="item.ticketTemplateId" v-for="(item,index) in ticketList" :key="index" >{{item.name}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12" v-show="showDetail">
                                <a-form-item v-if="ticketDetail.useNum === -1" label="可使用次数" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                                    <a-input-number style="width:100%" disabled placeholder="不限次卡" /> 
                                </a-form-item>
                                <a-form-item v-else label="可使用次数" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                                    <!-- :disabled="ticketDetail.useNum > 0" -->
                                    <a-input-number :disabled="ticketDetail.useNum > 0" style="width:100%" placeholder="请输入可使用次数（慎重填写）" :min="0" :precision="0" v-decorator="['availableTimes', {initialValue: ticketDetail.useNum}, {rules: [{required: true, message: '请输入可使用次数'}]}]" /> 
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row v-show="showDetail">
                            <a-col :span="12">
                                <a-form-item label="票/卡券类型" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                                    <a-input :value="['','期限卡','次卡','套餐票','线下票'][ticketDetail.type]" disabled></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="票/卡券金额" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                                    <span>{{ticketDetail.sellPrice}} 元</span>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row v-show="showDetail">
                            <a-col :span="12">
                                <a-form-item label="使用有效期" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                                    <span>{{receivableDate}}</span>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="应收金额" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                                    <span>{{receivableAmount}} 元</span>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="12">
                                <a-form-item label="收款方式" :labelCol="labelCol" :wrapperCol="{span: 18}" >
                                    <a-radio-group name="payMode" v-decorator="['payMode',{initialValue:4}]">
                                        <a-radio :value="4">现金</a-radio>
                                        <a-radio disabled :value="2">微信</a-radio>
                                        <a-radio disabled :value="1">支付宝</a-radio>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="实收金额" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                                    <a-input-number :precision="2" :min="0" placeholder="请输入" @change="amountChange" style="width: 100%;" v-decorator="['amount', {rules: [{required: true, message: '请输入实收金额'}]}]" /> 
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="18">
                                <a-form-item label="备注" :labelCol="{span: 4}" :wrapperCol="wrapperCol" >
                                    <a-textarea style="resize: none; height: 100px;" placeholder="请输入" v-decorator="['remark', {rules: [{required: true, message: '备注'}, {max: 100, message: '备注请在100字以内！'}]}]" /> 
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form>
                </a-card>
                <section v-show="Boolean(ticketGiveDetail.gifts.length)">
                    <a-divider></a-divider>
                    <div class="give-info-container">
                        <div class="mb8">
                            <span class="font-bigger text-color-85">新票赠品信息</span>
                            <span class="text-primary ml24">该商品正处于活动“{{ticketGiveDetail.name}}”期间，是否赠送对应赠品？</span>
                        </div>
                        <a-spin :spinning="spinning">
                            <member-order-give-selector :isNewActivity="true" :ticketGiftDetail="ticketGiveDetail" type="upgradeNew" ref="targetGiveSelector"></member-order-give-selector>
                        </a-spin>
                    </div>
                </section>
                <section v-show="Boolean(visibleUpgrade && giveSelectorLength)">
                    <a-divider ></a-divider>
                    <div class="give-info-container">
                        <div class="mb8">
                            <span class="font-bigger text-color-85">原票赠品信息</span>
                            <span class="text-primary ml24">原票券为活动主商品，升级后以下原票券赠品将失效</span>
                        </div>
                        <member-order-give-selector :owner="data.phone" :ticketGivenId="data.userTicketNo" :disabled="true" type="upgrade" :isSelected="true" ref="giveSelector"></member-order-give-selector>
                    </div>
                </section>
        </a-modal>
        <!-- 操作2次确认 -->
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        title="票券升级"
        :visible="visibleConfirm2"
        @cancel="visibleConfirm2 = false"
        :width="600"
        >
            <div class="text-center font-bigger text-color-85 mb16">{{ticketDetail.name}}</div>
            <div class="text-primary mb16">活动商品确认：</div>
            <a-table
            bordered
            :columns="columns"
            :rowKey="(item, index) => index"
            :dataSource="confirmDataSource"
            :pagination="false"
            :scroll="{y: 250}"
            >
                <template slot="type" slot-scope="key, row, index">
                    {{["", "票券", "优惠券", "储值卡", "积分"][key]}}
                </template>
            </a-table>
            <template slot="footer">
                <a-button @click="visibleConfirm2 = false">取消</a-button>
                <a-button type="primary" :loading="confirmLoading" @click="handleCreateUpgrade(false)">确定</a-button>
            </template>
        </a-modal>
        <!-- 操作积分、储值余额不足提示 -->
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        title="提示"
        :visible="visibleConfirm"
        @cancel="visibleConfirm = false"
        :width="420"
        >
            <div>
                该笔订单积分、储值余额不足，是否继续进行票券升级？
            </div>
            <div>
                票券升级后，该账户积分、储值余额将会清0。
            </div>
            <template slot="footer">
                <a-button @click="visibleConfirm = false">取消</a-button>
                <a-button type="primary" :loading="confirmLoading" @click="handleCreateUpgrade(true)">确定</a-button>
            </template>
        </a-modal>
        <order-pay ref="orderPay" @payCallback="closeModalUpgrade" :isServeOrder="1"></order-pay>
    </div>
</template>

<script>

    /**
     * 升级组件
     * @prop {Object} ticketData 基础卡对象
     * @prop {Boolean} visibleUpgrade 控制退款弹窗是否显示
     *
     * @func closeModalUpgrade 通知父组件关闭退款弹窗
     */
    import OrderPay from "@/components/modules/order/order-pay.component";
    import memberCard from "@/components/modules/order/member-card.component";
    import memberOrderGiveSelector from '@/components/modules/order/member-order-give-selector.component';
    import { mapGetters } from "vuex";

    let columns = [
        {
            title: '赠送商品名称',
            dataIndex: 'goodsName',
        },
        {
            title: '赠送商品类型',
            dataIndex: 'type',
            scopedSlots: { customRender: "type" },
            width: 100
        },
        {
            title: '赠送数量',
            dataIndex: 'number',
            width: 100
        }
    ];
    export default {
        name: "member-order-upgrade",
        zh: "升级组件",
        data() {
            return {
                columns,
                labelCol: {span: 6},
                wrapperCol: {span: 16},
                //基础卡对象
                data: {},
                // 票券下拉列表
                ticketList: [],
                // 升级后的票券详情
                ticketDetail: {},
                // 升级后的票券赠品信息
                ticketGiveDetail: {gifts: []},
                showDetail: false,
                confirmLoading: false,
                shopList: [],
                dataSource: [],
                visibleConfirm: false,
                visibleConfirm2: false,
                spinning: false,
                confirmDataSource: [],
                giveSelectorLength: 0,
                upgradeTicketType: 2,
            };
        },
        props: {
            ticketData: {type: Object},
            visibleUpgrade: {type: Boolean},
        },
        components: {
            memberCard,
            memberOrderGiveSelector,
            OrderPay
        },
        methods: {
            /**
             * @amountChange 实收金额变更事件
             */
            amountChange(val) {
                if (this.ticketGiveDetail.pointType !== 3) {
                    return false;
                }
                let pointGift = this.ticketGiveDetail.gifts.find(item => item.type === 4);
                pointGift.number = Math.floor(val * this.ticketGiveDetail.pointMultiple);
            },
            /**
             * @showConfirm 升级赠品确认
             */
            showConfirm() {
                this.formModelUpgrade.validateFields((err, values) => {
                    if (err) {
                        return false;
                    }
                    let { targetGiveSelector } = this.$refs;
                    if (Boolean(targetGiveSelector)) {
                        this.confirmDataSource = targetGiveSelector.getSelectedRows().filter(el => el.number);
                    }
                    if (!Boolean(targetGiveSelector) || !Boolean(this.confirmDataSource.length)) {
                        this.handleCreateUpgrade(false);
                        return false;
                    }
                    this.visibleConfirm2 = true;
                });
            },
            onChangeType(type) {
                this.upgradeTicketType = type;
                let shopId = this.formModelUpgrade.getFieldValue("shopId");
                this.changeUpgradeTicket(shopId);
            },
            changeUpgradeTicket(shopId) {
                if (!shopId) return;
                this.upgradeTicketType == 1 ? this.getTicketList(shopId) : this.getActivityTicketList(shopId);
            },
            getActivityTicketList(shopId) {
                if (!shopId || !this.data.ticketTemplateId) return;
                this.$api.order.queryShopAllActivityTicketFromUpgrade({
                    body: {
                        shopId: shopId,
                        originalPrice: this.data.sellShowPrice,
                    }
                }).then(res => {
                    if (!res) return;
                    res.forEach(el => {
                        el.sellPrice = el.sellShowPrice;
                    })
                    this.ticketList = res
                });
            },
            // 获取所有票券下拉
            getTicketList(shopId) {
                if (!shopId || !this.data.ticketTemplateId) return;
                this.$api.order.upTicketList({
                    params: {
                        shopId: shopId,
                        ticketId: this.data.ticketTemplateId,
                    }
                }).then(res => {
                    // res.forEach(el => {
                    //     el.sellPrice = el.sellShowPrice;
                    // })
                    this.ticketList = res || [];
                });
            },
            changeTicket(value) {
                this.getTicketDetail(value)
                this.showDetail = true
            },
            /**
             * @getShopList 获取门店列表
             */
            // 获取要升级的目标票
            getTicketDetail(id) {
                this.ticketDetail = this.ticketList.find(item => item.ticketTemplateId === id);
                this.ticketDetail.calculateType && this.$nextTick(() =>{
                    this.formModelUpgrade.setFieldsValue({availableTimes: this.ticketDetail.useNum})
                })
                this.getTicketGiveInfoVo();
            },
            // 升级保存
            handleCreateUpgrade(ignoreNotEnough) {
                this.formModelUpgrade.validateFields((err, values) => {
                    if (err) {
                        return false;
                    }
                    let upgradeGiveActivityDetails = [];
                    let { targetGiveSelector } = this.$refs;
                    if (Boolean(targetGiveSelector) && targetGiveSelector.getSelectedRows()) {
                        upgradeGiveActivityDetails.push({
                            operateNum: 1,
                            ticketTemplateId: this.ticketDetail.ticketTemplateId,
                            operateObjectCategory: "TICKET",
                            isMainGoods: true,
                        })
                        targetGiveSelector.getSelectedRows().forEach( el => {
                            switch (el.type) {
                                case 1:
                                    upgradeGiveActivityDetails.push({
                                        operateNum: el.number,
                                        ticketTemplateId: el.giveId,
                                        operateObjectCategory: "TICKET",
                                    })
                                    break;
                                case 2:
                                    upgradeGiveActivityDetails.push({
                                        operateNum: el.number,
                                        operateObjectCategory: "COUPON",
                                        couponTemplateId: el.giveId,
                                    })
                                    break;
                                case 3:
                                    upgradeGiveActivityDetails.push({
                                        operateNum: el.number,
                                        balanceCardId: el.giveId,
                                        operateObjectCategory: "BALANCE",
                                    })
                                    break;
                                case 4:
                                    if (el.number) {
                                        upgradeGiveActivityDetails.push({
                                            operateObjectCategory: "POINT",
                                            pointNum: el.number,
                                        })
                                    }
                                    break;
                                default:
                                    break;
                            }
                        })
                    }
                    let originalGiveActivityDetails = [];
                    let { giveSelector } = this.$refs;
                    if (Boolean(giveSelector) && giveSelector.getSelectedRows()) {
                        originalGiveActivityDetails.push({
                            isMainGoods: true,
                            operateNum: 1,
                            operateObjectCategory: "TICKET",
                            userTicketNo: this.data.userTicketNo,
                        })
                        giveSelector.getSelectedRows().forEach(el => {
                            switch (el.goodsType) {
                                case 1:
                                    originalGiveActivityDetails.push({
                                        operateNum: el.goodsNum,
                                        operateObjectCategory: "TICKET",
                                        userTicketNo: el.userTicketNo,
                                    })
                                    break;
                                case 7:
                                    originalGiveActivityDetails.push({
                                        operateNum: el.goodsNum,
                                        operateObjectCategory: "COUPON",
                                        userCouponNo: el.userCouponId,
                                    })
                                    break;
                                case 5:
                                    originalGiveActivityDetails.push({
                                        operateNum: el.goodsNum,
                                        balanceCardId: el.goodsId,
                                        operateObjectCategory: "BALANCE",
                                    })
                                    break;
                                case 8:
                                    originalGiveActivityDetails.push({
                                        operateObjectCategory: "POINT",
                                        pointNum: el.grantNum,
                                    })
                                    break;
                                default:
                                    break;
                            }
                        })
                    }
                    this.confirmLoading = true;
                    this.$api.order.userTicketOrderUpgrade({
                        body: {
                            ...values,
                            originalGiveActivityDetails,
                            upgradeGiveActivityDetails,
                            originalGoodsType: this.data.isActivity ? "ACTIVITY" : "TICKET",
                            upgradeGoodsType: this.ticketGiveDetail && this.ticketGiveDetail.gifts.length ? "ACTIVITY" : "TICKET",
                            goodsTemplateId: this.ticketGiveDetail && this.ticketGiveDetail.gifts.length ? this.ticketGiveDetail.id : this.ticketDetail.ticketTemplateId,
                            phone: this.data.phone,
                            originalGoods: this.data.isActivity ? this.data.giveGrantId : this.data.userTicketNo,
                            userId: this.data.userId,
                            shopName: this.shopList.filter(item => item.shopId == values.shopId)[0].shopName,
                        }
                    }).then(res => {
                        this.confirmLoading = false;
                        this.visibleConfirm2 = false;
                        this.$refs.orderPay.orderId = res || '';
                        this.$refs.orderPay.userId =  this.ticketData.userId;
                    }).catch(err => {
                        this.confirmLoading = false;
                        if (err && err.code === 200001) {
                            this.$message.error(err.msg);
                        }
                    });
                });
            },
            closeModalUpgrade() {
                this.ticketList = [];
                this.ticketGiveDetail = {gifts: []};
                setTimeout(() => {
                    this.$emit('changeVisibleUpgrade', false)
                }, 750);
                this.showDetail = false;
                this.confirmLoading = false;
                this.confirmLoading2 = false;
            },
            /**
             * @getTicketGiveInfoVo 获取目标票券赠品的信息
             */
            getTicketGiveInfoVo() {
                this.spinning = true;
                if (Boolean(this.$refs.targetGiveSelector)) {
                    this.$refs.targetGiveSelector.selectedRows = [];
                    this.$refs.targetGiveSelector.selectedRowKeys = [];
                }
                this.$api.member.getTicketGiveInfoVoByTicketId({
                    params: {
                        ticketId: this.ticketDetail.ticketTemplateId
                    }
                }).then(res => {
                    this.spinning = false;
                    if (!res) {
                        this.ticketGiveDetail = {gifts: []};
                        return
                    }
                    res && res.gifts.forEach(item => {
                        item.goodsName = item.showName || item.name;
                    });
                    let obj = {};
                    //pointType 1不送积分，2固定，3订单金额倍数积分
                    switch(res.pointType) {
                        case 2: 
                            obj.goodsName = '积分';
                            obj.type = 4;
                            obj.number = res.pointNum;
                            res.gifts.push(obj);
                            break;
                        case 3: 
                            let amount = this.formModelUpgrade.getFieldValue('amount');
                            obj.goodsName = '积分';
                            obj.type = 4;
                            obj.number = typeof amount !== 'undefined' ? Math.floor(amount * res.pointMultiple) : 0;
                            res.gifts.push(obj);
                            break;
                    }
                    this.ticketGiveDetail = res;
                    let ticketDetail = this.ticketGiveDetail.ticketGiveTicketVos.find( el => el.ticketId == this.ticketDetail.ticketTemplateId)
                    this.ticketDetail.sellPrice = ticketDetail.sellPrice;
                }).catch( err => {
                    this.spinning = false;
                })
            },
            payOrder(reqData) {
                this.confirmLoading = true;
                this.$api.order.payOrder({
                    body: {
                        ...reqData
                    }
                }).then(res => {
                    this.formModelUpgrade.resetFields();
                    this.confirmLoading = false;
                    this.visibleConfirm = false;
                    this.visibleConfirm2 = false;
                    this.confirmDataSource = [];
                    this.ticketGiveDetail = {gifts: []};
                    this.$message.success('操作成功');
                    this.closeModalUpgrade();
                }).catch(err => {
                    this.confirmLoading = false;
                });
            }
        },
        beforeCreate() {
            this.formModelUpgrade = this.$form.createForm(this);
        },
        created() {},
        updated() {},
        mounted() {},
        computed: {
            'receivableAmount'() {
                return (this.ticketDetail.sellPrice < this.data.sellShowPrice) ? 0 :(this.ticketDetail.sellPrice - this.data.sellShowPrice).toFixed(2)
            },
            'receivableDate'() {
                if (this.ticketDetail.validTimeSetMode == 1) {
                    return this.$moment().format("YYYY-MM-DD") + "~" + this.$moment().add(this.ticketDetail.validTimeSetParam, 'months').format("YYYY-MM-DD")
                } else {
                    return this.ticketDetail.validTimeSetParam;
                }
            },
            ...mapGetters(["shopId"])
        },
        watch: {
            'ticketData'(val) {
                this.ticketList = [];
                val.suitShopReserveStockConfigs.forEach( el => {
                    el.label = el.shopName;
                    el.value = el.shopId;
                })
                this.shopList = val.suitShopReserveStockConfigs;
                this.data = val;
            },
            'visibleUpgrade'(val) {
                if (val) {
                    this.$nextTick(() => {
                        this.$refs.giveSelector.getUserTicketGiveInfoVo().then(res => {
                            this.giveSelectorLength = res && res.length;
                        })
                    })
                }
            },
        }
    };
</script>

<style lang="scss">
.upgrade-wrap {
    .ant-card-head {
        background: #f5f5f5 !important;
    border-bottom: 1px solid #e8e8e8;
    padding: 0 24px;
    border-radius: 2px 2px 0 0;
    zoom: 1;
    margin-bottom: -1px;
    min-height: 48px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    }
    .ant-card-body {
        padding: 0 !important;
    }
}
.give-info-container {
    background-color: #f3f3f3;
    padding: 14px;
}
</style>
